/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateAccountPassword.defs.js'
export { main as default } from './updateAccountPassword.defs.js'
